var map = {
	"./back.svg": "7338",
	"./bag-cart.svg": "9ef2",
	"./bag-handle.svg": "24fb",
	"./bag.svg": "47fd",
	"./book-pages.svg": "abf9",
	"./book.svg": "fc4e",
	"./box-square.svg": "ae59",
	"./box.svg": "bb19",
	"./cube-big.svg": "4eba",
	"./cube.svg": "e952",
	"./delivery.png": "6361",
	"./expand-outline.svg": "3d83",
	"./facebook-icon-mini-black.png": "b956",
	"./facebook-icon-mini-white.png": "7337",
	"./facebook.svg": "8485",
	"./gallery.svg": "6ec0",
	"./googlemaps.svg": "5c95",
	"./library.svg": "a170",
	"./mail.svg": "3ae9",
	"./menu.svg": "d17f",
	"./news.svg": "f212",
	"./next.svg": "0043",
	"./payment.png": "6b59",
	"./replacement.png": "b76f",
	"./scan-outline.svg": "4c62",
	"./scholar.svg": "98e3",
	"./tag-big.svg": "1bf8",
	"./tag.svg": "81fd",
	"./tags-big.svg": "a942",
	"./tags.svg": "6ba8",
	"./whatsapp.svg": "7583"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";